import { ColorV2 } from "config/colors";
import styled from "styled-components";

export const ShiftRow = styled.div`
  width: 100%;
  display: grid;
  grid-template-columns: minmax(0, 1fr) auto auto;
  align-items: center;
  gap: 12px;
  min-height: 56px;
  padding: 8px 12px;
  border-radius: 16px;
  background: ${ColorV2.White};
`;

export const EditableShiftRow = styled(ShiftRow)`
  border-radius: 18px;
  box-shadow: 0 8px 20px rgba(15, 42, 64, 0.12);
`;

export const ShiftRowLeft = styled.div`
  display: flex;
  align-items: center;
  gap: 14px;
  min-width: 0;
  grid-column: 1 / 2;
`;

export const EditableShiftRowLeft = styled(ShiftRowLeft)`
  gap: 10px;
`;

export const ShiftRowRight = styled.div`
  display: flex;
  align-items: center;
  justify-content: flex-end;
  gap: 6px;
  grid-column: 2 / 4;
  min-width: 0;
`;

export const ShiftMetaRow = styled.div`
  display: flex;
  align-items: center;
  gap: 12px;
  justify-content: flex-end;
  min-width: 220px;
`;

export const EditShiftMetaRow = styled(ShiftMetaRow)`
  justify-content: flex-start;
  gap: 8px;
  min-width: 0;
  flex-wrap: nowrap;
`;

export const ShiftActionsRow = styled.div`
  position: relative;
  z-index: 4;
  display: flex;
  align-items: center;
  gap: 16px;
  justify-content: flex-end;
`;

export const ActionsWrap = styled.button`
  position: relative;
  z-index: 5;
  border: none;
  background: transparent;
  padding: 0;
  width: 24px;
  height: 24px;
  display: flex;
  align-items: center;
  justify-content: center;
  cursor: pointer;
`;

export const EditTimeWrap = styled.div`
  width: 115px;
`;

export const EditStartTimeWrap = styled(EditTimeWrap)`
  margin-left: 0;
`;

export const Dash = styled.span`
  color: ${ColorV2.Blue1};
  font-weight: 700;
`;

export const BreakWrap = styled.div`
  display: inline-flex;
  align-items: center;
  gap: 8px;
`;

export const EditBreakWrap = styled(BreakWrap)`
  margin-left: 0;
  min-width: 0;
`;

export const EditDeductionWrap = styled(BreakWrap)`
  margin-left: 0;
  min-width: 0;
`;

export const BreakInputWrap = styled.div`
  width: 64px;
  min-width: 64px;
`;

export const HiddenDuration = styled.span`
  display: none;
  width: 0;
  visibility: hidden;
  pointer-events: none;
`;

export const ShiftDateCell = styled.div`
  width: 90px;
  min-width: 90px;
`;

export const ShiftWarningCell = styled.div`
  width: 20px;
  min-width: 20px;
  display: inline-flex;
  align-items: center;
  justify-content: center;
`;

export const ShiftTimeCell = styled.div`
  width: 132px;
  min-width: 132px;
`;

export const ShiftBreakCell = styled.div`
  width: 92px;
  min-width: 92px;
  text-align: left;
`;

export const ShiftDeductionCell = styled.div`
  width: 124px;
  min-width: 124px;
  text-align: right;
  white-space: nowrap;
`;

export const ShiftDurationCell = styled.div`
  width: 62px;
  min-width: 62px;
  text-align: right;
`;
